module.exports = __webpack_public_path__ + "static/pt-sans-v12-latin-700-09d43f89ee9f28893c5d175f5eff5045.woff";